import React, { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export const Textarea = ({
  className,
  name = "",
  placeholder = "",
  value = "",
  id = "",
  rows,
  onChange
}) => {
  const [defaultRows, setDefaultRows] = useState(1);

  useEffect(() => setDefaultRows(rows), [rows]);

  return (
    <textarea
      name={name}
      id={id}
      value={value}
      rows={defaultRows}
      onChange={(e) => onChange(e)}
      className={twMerge(
        className,
        "p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
      )}
      placeholder={placeholder}
    />
  );
};
